import { numberOptionalSerializer, queryStateAtom } from 'sierra-client/lib/querystate/use-query-state'

export const transcriptionSegmentIndexAtom = queryStateAtom(numberOptionalSerializer, undefined, 'i')
